module.exports = __webpack_public_path__ + "assets/img/report-data-bg-5.45a89817.png";